import { lightingAdapter, LightingState } from './lighting.entity';
import { createReducer, on, Action, combineReducers, ActionReducerMap } from '@ngrx/store';
import * as themesReducer from './themes/theme.reducer';
import * as themesStatusReducer from './themes-status/themes-status.reducer';
import * as themeScheduleSummaryReducer from './theme-schedule-summary/theme-schedule-summary.reducer';
import * as scenesReducers from './scenes/scene.reducer';
import * as scenesStatusReducers from './scenes-status/scenes-status.reducer';
import * as sceneScheduleSummaryReducer from './scene-schedule-summary/scene-schedule-summary.reducer';
import * as cctColorsReducer from './cct-color/cct-color.reducers';
import * as rgbColorsReducer from './rgb-color/rgb-color.reducers';

import { scenesAdapter } from './scenes/scene.entity';
import { themesAdapter } from './themes/theme.entity';
import { themesStatusAdapter } from './themes-status/themes-status.entity';
import { sceneScheduleSummaryAdapter } from './scene-schedule-summary/scene-schedule-summary.entity';
import { themeScheduleSummaryAdapter } from './theme-schedule-summary/theme-schedule-summary.entity';
import { cctColorAdapter } from './cct-color/cct-color.entity';
import { rgbColorAdapter } from './rgb-color/rgb-color.entity';
import { ToroLocationApanSetup } from './../../api/models/toro-location-apan-setup.model';
import { scenesStatusAdapter } from './scenes-status/scenes-status.entity';

export const initialState: LightingState = lightingAdapter.getInitialState({
    ids: [],
    entities: null,
    scenes: scenesReducers.initialState,
    themes: themesReducer.initialState,
    scenesStatus: scenesStatusReducers.initialState,
    themesStatus: themesStatusReducer.initialState,
    cctColors: cctColorsReducer.initialState,
    rgbColors: rgbColorsReducer.initialState,
    sceneScheduleSummaryList: sceneScheduleSummaryReducer.initialState,
    themeScheduleSummaryList: themeScheduleSummaryReducer.initialState,
});

// export const lightingReducerObj = createReducer(
//     initialState,

// );

export function lightingReducer(state: LightingState, action: Action): LightingState {
    return combineReducers({
        themes: themesReducer.reducer,
        themesStatus: themesStatusReducer.reducer,
        themeScheduleSummaryList: themeScheduleSummaryReducer.reducer,
        scenes: scenesReducers.reducer,
        scenesStatus: scenesStatusReducers.reducer,
        sceneScheduleSummaryList: sceneScheduleSummaryReducer.reducer,
        cctColors: cctColorsReducer.cctColorReducer,
        rgbColors: rgbColorsReducer.rgbColorReducer
    })(state, action) as LightingState;
}

// export const lightingReducer: ActionReducerMap<LightingState & any> = {
//     themes: themesReducer.reducer,
//     scenes: scenesReducers.reducer,
//     sceneScheduleSummaryList: sceneScheduleSummaryReducer.reducer,
//     themeScheduleSummaryList: themeScheduleSummaryReducer.reducer,
//     ids: undefined,
//     entities: undefined,
//     area: undefined
// }

// export const lightingReducer = createReducer(initialState);

export const scenesSelectros = scenesAdapter.getSelectors();
export const themesSelectors = themesAdapter.getSelectors();
export const themesStatusSelectors = themesStatusAdapter.getSelectors();
export const scenesStatusSelectors = scenesStatusAdapter.getSelectors();
export const sceneScheduleSummarySelectors = sceneScheduleSummaryAdapter.getSelectors();
export const themeScheduleSummarySelectros = themeScheduleSummaryAdapter.getSelectors();
export const cctColorSelectors = cctColorAdapter.getSelectors();
export const rgbColorSelectors = rgbColorAdapter.getSelectors();


